import React, { Component } from 'react';
import { connect } from '@souche-f2e/muji';
import { dispatch } from '@@/store';
import { Modal, ConfigProvider } from 'antd';
import zh_CN from 'antd/es/locale/zh_CN';
import Detail from './Detail';
const mapStateToProps = (rootState) => ({
    carDetail: rootState.carDetail,
});
class DetailIndex extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    componentWillUnmount() {
        dispatch.carDetail.resetState({});
        dispatch.carDetail.resetState({});
    }
    render() {
        const { showDetail, showFooter, } = this.props.carDetail;
        const { footerRender } = this.props;
        // @ts-ignore
        return (<ConfigProvider locale={zh_CN}>
        <Modal width={1200} title={'车辆详情'} visible={showDetail} afterClose={() => {
            dispatch.carDetail.resetState({});
        }} onCancel={() => {
            dispatch.carDetail.show(false);
        }} footer={(showFooter && footerRender) ? footerRender() : null}>
          <Detail />
        </Modal>
      </ConfigProvider>);
    }
}
const DetailProps = connect(mapStateToProps, null, null, { forwardRef: true })(DetailIndex);
export default DetailProps;
